import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../static/css/homePage.css';

import bestSellerBouquets from '../static/images/bestSellerYellow.jpg'
import bestSellerRoses from '../static/images/bestSellerRose.PNG'
import bestSellerBirthday from '../static/images/birthday_flowers.jpg'
import valentinesDaySpecial from '../static/images/valentinesdayspecial.jpg'
import collectionWeddingBouquets from '../static/images/wedding.jpg'
import collectionGraduationBouquets from '../static/images/graduation_image.jpg'
import collectionCNStyle from '../static/images/CN_style.jpg'
import monthlySubImage from '../static/images/monthly_sub.jpg'
import vDayPromoImage from "../static/images/V-day_promo.jpeg"
import Cards from '../components/card';
import Footer from '../components/footer';
import NavBar from '../components/navBar';
import LinkComponent from '../components/link';
import HeartAnimation from '../components/heartAnimation';
import { useRedirectPageHelper } from '../utilies/utilies';
import PromoModal from '../components/promoModal';

import { useRef } from 'react';

//SectionComponents
function WelcomeSection() {
    return (
        <section id="welcomeSection">
            <div className="container-fluid m-0 p-0">
                <div className="overflow-hidden w-100 d-flex flex-column welcome-section">
                    <div className="d-flex flex-column align-items-center position-absolute top-50 start-50 translate-middle-x">
                        <h1 className="my-3 text-center text-light" style={{fontSize: "clamp(3em,3vw,8em)"}}>SWEETWOOD FLORA</h1>
                        <LinkComponent link={"/inventory"} component={<button className="border-bottom my-5 btn btn-dark welcome-section-button" style={{fontSize: "clamp(1.5em,3vw,3em)"}}>Shop Now</button>}/>
                    </div>
                </div>
            </div>
        </section>
    );
}

function BestSellerSection() {
    const heartContainerRef = useRef(null);
    const redirectPageHelper = useRedirectPageHelper();
    return (
        <section id="bestSeller" className='m-0 p-0'>
            <div ref={heartContainerRef} className="container-fluid m-0 p-0 position-relative" style={{backgroundColor: "hsla(0,0%,85.1%,1)"}}>
                <HeartAnimation containerRef={heartContainerRef} />
                 <div className="snow"></div> 
                 <div className="container-fluid">
                    <div className="container justify-content-center d-flex my-0 py-5">
                        <h1 className="section-h1">
                        </h1>
                    </div>
                </div>
                 <div className="container" style={{width: "100vw"}}>
                    <div className="row gap-5 card-group mx-0 py-5 justify-content-center flex-wrap">
                        <Cards context={"h"} text={"Best Seller"} alt={"best_seller"} images={[bestSellerBouquets]} redirectPath={"/inventory"} redirectContext={"Best Seller"}/>
                        <Cards context={"h"} text={"Roses"} alt={"roses"} images={[bestSellerRoses]} redirectPath={"/inventory"} redirectContext={"Roses"}/>
                        {/* <Cards context={"h"} text={"Birthday Flowers"} alt={"birthday_flowers"} images={[bestSellerBirthday]} redirectPath={"/inventory"} redirectContext={"Birthday"}/> */}
                    </div>  
                </div> 
            </div>
            <div
            ref={heartContainerRef}
            className="container-fluid m-0 p-0 position-relative"
            style={{
              width: "100vw",  // Full width of the viewport
              overflow: "hidden", // To prevent hearts from overflowing
              zIndex:10}}>
            <HeartAnimation containerRef={heartContainerRef} />
            <div className="container d-flex flex-column py-3" style={{ width: "100vw" }}>
              <img className="mx-auto" src={valentinesDaySpecial} style={{ width: "100%" }} />
              <button onClick={() => redirectPageHelper("/inventory", { category: "Valentine's Day" })} className="btn btn-dark mx-auto mt-3" style={{fontSize: "clamp(1em,1.5vw,5em)"}}>Learn More</button>
            </div>
            </div>
        </section>
    );
}

// function CollectionSection() {
//     return (
//         <section id="collectionSection">
//             <div className="container-fluid m-0 p-0">
//                 <div className="overflow-hidden w-75 d-flex collection-section mx-auto">
//                 </div>
//             </div>
//         </section>
//     );
// }

function CollectionSellSection() {
    return (
        <section id="CollectionSell">
            <div className="container-fluid m-0 p-0 position-relative" style={{backgroundColor: "hsla(0,0%,85.1%,1)"}}>
                <div className="snow"></div>
                <div className="container-fluid">
                    <div className="container justify-content-center d-flex my-0 py-5">
                        <h1 className="section-h1">
                            Collection
                        </h1>
                    </div>
                </div>
                <div className="container-md">
                    <div className="row gap-5 card-group mx-0 justify-content-center flex-wrap">
                        <Cards context={"h"} text={"Wedding Bouquets"} alt={"wedding_bouquets"} images={[collectionWeddingBouquets]} redirectPath={"/inventory"} redirectContext={"Wedding"}/>
                        <Cards context={"h"} text={"Graduation Bouquets"} alt={"graduation_bouquets"} images={[collectionGraduationBouquets]} redirectPath={"/inventory"} redirectContext={"Graduation"}/>
                        {/* <Cards context={"h"} text={"Modern CN Style"} alt={"CN_styles"} images={[collectionCNStyle]} redirectPath={"/inventory"} redirectContext={"New CN Style"}/> */}
                    </div>  
                </div>
            </div>
        </section>
    );
}

function MonthlySubSection() {
    return (
        <section id="monthly_subscription" style={{backgroundColor: "hsla(0,0%,85.1%,1)"}}>
            <div className="container w-75 d-flex flex-row custom-monthly-section align-items-center justify-content-center py-3">
                <div className="container w-50 justify-content-center custom-monthly-div d-flex">
                    <img src={monthlySubImage} alt="monthly_sub_image" style={{objectFit: "cover", height: "40vh", width: "100%"}} />
                </div>
                <div className="container w-50 my-5 flex-column justify-content-center custom-monthly-div align-items-center">
                    <div className='text-center my-2'>
                        <h1 style={{fontSize: "4rem"}}>
                            Monthly Flower
                        </h1>
                    </div>
                    <div className='text-center my-2'>
                        <h1>Subscription</h1>
                    </div>
                    <div className='my-2 d-flex justify-content-center' style={{fontSize: "clamp(0.2rem, 4vw, 1.5rem)"}}>
                        <ul>
                            <li>
                                <p>Keep happiness blooming month after month</p>
                            </li>
                            <li>
                                <p>
                                    Fresh flowers every month starting at $89 + free shipping
                                </p>
                            </li>
                            <li>
                                <p>
                                    Pause or cancel any time, stress free
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center my-0'>
                <LinkComponent link={"/payment"} component={<button href="#footerSection" className="btn rounded bg-transparent border-1 border-dark subscribe-section-button" style={{fontSize: "2rem", marginBottom: "10rem"}}>
                    Sign Up!
                </button>}/>
            </div>
        </section>
    );
}

function HomePage() {
    return (
        <div>
            <NavBar />
            <WelcomeSection />
            <BestSellerSection />
            {/* Promo modal should go here */}
            <PromoModal showOnLoad={true} 
                image={vDayPromoImage}
                title="Valentine’s Day Special" 
                message="Save on romantic bouquets — limited time!" 
                buttonText="Browse Categories" 
                buttonLink="/categories" 
            />
            {/* <CollectionSection /> */}
            <CollectionSellSection />
            <MonthlySubSection />
            <Footer />
        </div>
    );
}

export default HomePage;